import { debounce as _debounce } from 'es-toolkit';
import slideshowSwiper from './slideshowSwiper';
import { gsap } from 'gsap';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { IdleObserver } from '@idle-observer/core';
import screenfull from 'screenfull';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';

gsap.registerPlugin( DrawSVGPlugin );


export default class {

	constructor(options) {

		// OPTIONS
		this.defaults = {
            el: undefined,
            main: undefined,

            // if it always stays instead of beign remove each time a new page load
            isGlobal: true,

            debug : false, // open to check all the csss

            // to close the window if clicked outside the window
            clickOut: true,

            autoplayInterval: 4000

		}

		this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace = 'window-enlarge-images';

		// DOM ELEMENT !!!!!!!!!!
		this.el = this.options.el;
        this.main = this.options.main;

		// VARS (vanilla DOM)
		this.window = window;
		this.document = document;
		this.htmlEl = document.documentElement;
		this.body = document.body;

        this.classImageEnlarge = this.el.getAttribute( 'data-trigger' );
        this.renderOverlay(true);


		// init!!!!
		this.init(true);

	}

	init(b) {


        console.log( 'init window enlarge images, b ' + b );

        if ( b ){
            // create slider before initialize
            this.createSlider(true);
        }
        this.initSlider(b);
		this.addEvents(b);

        // to debug the css of the overaly open when page load
        if ( b && this.options.debug ){
            this.open( true );
        }
	}

    renderOverlay(b){
        if ( b ){
            this.body.append( this.el );
        }
        else{
            this.el.remove();
        }
    }

    // this is where we scan page an append cloned images to slider
    createSlider( b ){
        if ( b ){
            this.createSlider( false );
            let els = Array.from( document.querySelectorAll( '.' + this.classImageEnlarge ) );
            if ( els.length ){
                let wrapper = this.el.querySelector( '.swiper .swiper-wrapper' ),
                img, slide;

                els.forEach( (el, i) =>{

                    // set index
                    el.setAttribute( 'data-index', i );

                    //clone image
                    img = el.querySelector( 'img' );

                    // create the swiper slide
                    const template = document.createElement( 'template' );
                    template.innerHTML = '<div class="swiper-slide">' + img.outerHTML + '</div>';
                    slide = template.content.children;

                    // append
                    wrapper.append( slide[0] );

                });
            }
        }
        else{
            let slides = this.el.querySelectorAll( '.swiper-slide' );
            if ( slides.length ){
                for ( const s of slides ){
                    s.remove();
                }
            }
        }
    }


	initSlider(b) {
        const slides = this.el.querySelectorAll( '.swiper-slide' ),
            controls = this.el.querySelector( '.controls' );
        if ( ! slides.length ){
            return;
        };
        const el = this.el.querySelector('.swiper');
        if ( b ){
            const instance = new slideshowSwiper({ $el: el, main: this.main, prev: controls.querySelector( '.prev' ), next: controls.querySelector( '.next' ) });

            this.slider = instance;

            this.main.WIDGETS.assign(el, instance);

            this.maxSlides = this.slider.swiper.slides.length;

        } else {

            if ( this.slider ){
                this.slider.swiper.destroy();
            }

            this.main.WIDGETS.destroy(el);
        }
	}

    // this is called when window open, to set immediatly the correct index for sliders
    setSliderIndex( i ){
        this.slider.swiper.slideToLoop( i, 0 );
    }

	addEvents(b) {
		this.debounceResize(b);

        // if we add a link to home (logo)
        const logo = this.el.querySelector( '.logo' );

        if ( b ){
            // close window
            this.el.querySelector( '.close' )?.addEventListener( 'click', this.onCloseOverlay );
            // trigger to open window from team grid items
            document.querySelectorAll( '.' + this.classImageEnlarge ).forEach( el => el.addEventListener( 'click', this.onClikImage ) );

            if ( logo ){
                logo.addEventListener( 'click', this.onCloseOverlay );
            }
        }
        else{
            this.el.querySelector( '.close a' )?.removeEventListener( 'click', this.onCloseOverlay );
            document.querySelectorAll( '.' + this.classImageEnlarge ).forEach( el => el.removeEventListener( 'click', this.onClikImage ) );

            if ( logo ){
                logo.removeEventListener( 'click', this.onCloseOverlay );
            }
        }
        this.addKeyboardEvents(b);
        this.addFullscreenButton(b);
        this.initAutoplayButton( b );
	}

    addKeyboardEvents(b){
        if ( b ){
            document.addEventListener( 'keydown', this.onKeyPress );
        }
        else{
            document.removeEventListener( 'keypress', this.onKeyPress );
        }
    }

    onKeyPress = (e) => {
        switch( e.key ){
            case 'Escape':
                this.open( false );
                break;
        }
    }

    addFullscreenButton(b){
        const btn = this.el.querySelector( '.controls .fullscreen' );
        if ( !btn ){
            return;
        }
        if ( !screenfull.isEnabled ){
            btn.style.display = 'none';
            return;
        }
        if ( b ){
            btn.addEventListener( 'click', this.onToggleFullscreen );
            screenfull.on('change', this.onScreenfullChange);
        }
        else{
            btn.removeEventListener( 'click', this.onToggleFullscreen );
            screenfull.off('change', this.onScreenfullChange);
        }
    }

    onToggleFullscreen = (e) => {
        e.preventDefault();
        if ( screenfull.isEnabled ){
            screenfull.toggle( this.el );
        }
    }

    onScreenfullChange = () => {
        const btn = this.el.querySelector( '.controls .fullscreen' );
        if ( !btn ){
            return;
        }
        if ( screenfull.isFullscreen ){
            btn.classList.add( 'active' );
        }
        else{
            btn.classList.remove( 'active' );
        }
    }

    onCloseOverlay = (e) => {
        e.preventDefault();
        this.open( false );
    }

	debounceResize(b) {
		if (b) {
			// debounce resize
			this._debResize = _debounce(() => this.onResize(true), 17);
			window.addEventListener('resize', this._debResize);
		}
		else {
			if (this._debResize) {
				this._debResize.cancel && this._debResize.cancel();
				window.removeEventListener('resize', this._debResize);
			}
		}
	}

	onResize() {

	}

    // trigger
    onClikImage = ( e ) => {
        e.preventDefault();
        //console.log( e );
        let a = e.target.closest( '.' + this.classImageEnlarge ),
        i = 0;
        if ( a ){
            i = parseInt(a.getAttribute( 'data-index' ));
        }
        this.open( true, i );
    }

	// public methods //////////////////////////////////////////////////////////////////////////

    open(b,i=0){
        if ( this.el.classList.contains( 'active' ) === b ){
            return;
        }
        if ( b ){
            this.el.classList.add( 'active' );
            this.setSliderIndex( i );
            gsap.to( this.el, {opacity:1, duration:0.6, ease: 'power1.out' });
            disableBodyScroll( this.el.querySelector( '.content' ) );
        }
        else{
            gsap.to( this.el, {opacity:0, duration:0.6, ease: 'power1.out', onComplete: ()=>{ this.el.classList.remove( 'active' ) } });
            enableBodyScroll( this.el.querySelector( '.content' ) );
        }
        this.detectActivity( b );
        if ( !b ){
            this.activateAutoPlay( false )
        }
    }


    detectActivity( b ){

        if ( b ){
            this.el.classList.remove( 'idle' ) ;

            if ( !this.idleObserver ){

                // https://github.com/adbergen/idle-observer/tree/main

                let idleObserver = new IdleObserver({
                    timeout: 3000,
                    onIdle: () => {
                        this.el.classList.add( 'idle' ) ;
                    },
                    onActive: () => {
                        this.el.classList.remove( 'idle' ) ;
                    }
                });
                this.idleObserver = idleObserver;
            }
        }
        else{
            if ( this.idleObserver ){
                this.idleObserver.destroy();
                this.idleObserver = null;
            }
        }
    }

    nextAutoplaySlide(){
        console.log( 'nextAutoplaySlide' );
        if ( this.slider ){
            this.slider.swiper.slideNext();
            if ( this.isAutoplaying() ){
                this.activateAutoPlay( true );
            }
        }
    }


    //------------------------------------------ AUTOPLAY -----------------------------------------//

    initAutoplayButton( b ){
        const btn = this.el.querySelector( '#autoplay-indicator' );
        if ( !btn ){
            return;
        }
        this.btnAutoplay = btn;
        if ( b ){
            this.btnAutoplay.addEventListener( 'click', this.toggleAutoPlay );
        }
        else{
            this.btnAutoplay.removeEventListener( 'click', this.toggleAutoPlay );
        }
        this.initAutoplayIndicator( b );
    }


    activateAutoPlay( b ){

        console.log( 'activateAutoPlay, b ' + b );

        if ( this.autoplayInterval ){
            clearTimeout( this.autoplayInterval );
            this.autoplayInterval = false;
        }

        this.setAutoplayIndicatorState( b );

        if ( b ){
            this.autoplayInterval = setTimeout( ()=>this.nextAutoplaySlide(), this.options.autoplayInterval );
        }
    }

    setAutoplayIndicatorState( play ){
        if ( !this.indicator ){
            return;
        }
        if ( play ){
            this.indicator.el.classList.add( 'play-state' )
            this.indicator.el.classList.remove( 'pause-state' );
            this.updateAutoplayIndicator( this.options.autoplayInterval );
        }
        else{
            this.indicator.el.classList.add( 'pause-state' );
            this.indicator.el.classList.remove( 'play-state' );
            this.updateAutoplayIndicator( 0 );
        }
    }

    isAutoplaying(){
        return this.btnAutoplay.classList.contains( 'play-state' );
    }

    toggleAutoPlay = () =>{

        let isPlaying = this.btnAutoplay.classList.contains( 'play-state' );
        this.activateAutoPlay( !isPlaying );
    }

    initAutoplayIndicator(b){
        let indicator, svg;
        if ( b ){
            if ( !this.indicator ){
                indicator = this.btnAutoplay;
                if ( indicator ){
                    svg = indicator.querySelector( '.indicator svg' );
                    this.indicator = {
                        el: indicator,
                        svg: svg,
                        circle: svg.querySelector( 'circle' ),
                    };
                    this.updateAutoplayIndicator( 0 );
                }
            }
            else{
                this.updateAutoplayIndicator( 0 );
            }
        }
        else{
            this.updateAutoplayIndicator( 0 );
        }
    }

    updateAutoplayIndicator(progress){
        if ( this.indicator ){

            gsap.killTweensOf( this.indicator.circle  );

            if ( progress === 0 ){
                gsap.set( this.indicator.circle , { drawSVG: "0%" });
            }
            else{
                gsap.fromTo( this.indicator.circle , { drawSVG: "0%" }, {duration: progress/1000, drawSVG: "100%"} );
            }
        }
    }

	destroy() {
		this.init(false);
        if ( this.options.isGlobal ){
            return;
        }
        this.renderOverlay(false);
	}

}
